import getCaptionForElement from '../../common/helpers/get-caption-for-element';
import getLabelTriggerWidth from '../../control-pane/helpers/get-label-trigger-width';

function getCssCustomPropValue(prop, targetDocument) {
  return getComputedStyle(targetDocument.documentElement).getPropertyValue(prop);
}

function getCssCustomPropNumericValue(prop, targetDocument) {
  return parseInt(getCssCustomPropValue(prop, targetDocument), 10);
}

function getDragTriggerContainerLabeledProps(
  targetElement,
  targetDocument = document,
  isMergedWithTextTriggers
) {
  const glyphSize = 24;

  if (isMergedWithTextTriggers) {
    // According to design, the drag trigger has
    // a specific width when rendered without label
    const widthWithoutLabel = getCssCustomPropNumericValue(
      '--ws-drag-trigger-width--without-label',
      targetDocument
    );

    return {
      glyph: 'drag',
      glyphSize,
      width: widthWithoutLabel,
    };
  }

  const { label } = getCaptionForElement(targetElement);

  const triggerTotalWidth = getLabelTriggerWidth(label, true) + glyphSize;

  return {
    glyph: 'drag',
    glyphSize,
    width: triggerTotalWidth,
    label,
  };
}

export default getDragTriggerContainerLabeledProps;
